import { render, staticRenderFns } from "./DashboardLocal.vue?vue&type=template&id=783ef364&"
import script from "./DashboardLocal.vue?vue&type=script&lang=js&"
export * from "./DashboardLocal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports